import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { browserTracingIntegration, init, replayIntegration } from '@sentry/angular-ivy';
import { environment } from './environments/environment';

init({
  debug: false,
  dsn: environment.services.sentry.dsn,
  environment: environment.production ? 'production' : 'development',
  denyUrls: ['/localhost/i', '/127.0.0.1/i'],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  initialScope(scope) {
    return scope;
  },
  integrations: [browserTracingIntegration(), replayIntegration()],
  beforeSend: (event, hint) => {
    const isTimeoutException = hint.originalException === 'Timeout';
    const isLocalhost = window.location.hostname === 'localhost';
    if (isLocalhost || isTimeoutException) {
      return null;
    }
    return event;
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.production ? 1.0 : 0.1,
});

if (environment.production) {
  enableProdMode();
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => err);
